export const SECTION_TITLE = 'THƯ BÁC GỬI THANH NIÊN'

export const SLIDERS = [
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685258433/2022-2023/thu-gui-thanh-nien/TH%C6%AF_B%C3%81C_G%E1%BB%ACI_THANH_NI%C3%8AN_uq0exu.webp',
        title: '',
        content: ''
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685258082/2022-2023/thu-gui-thanh-nien/TH%C6%AF_B%C3%81C_G%E1%BB%ACI_THANH_NI%C3%8AN_uq0exu.webp',
        title: '',
        content: ''
    },
]

export const ITEMS = [ 
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685257729/2022-2023/thu-gui-thanh-nien/TH%C6%AF_B%C3%81C_G%E1%BB%ACI_THANH_NI%C3%8AN_1_wfqpkj.webp',
        title: '',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685257730/2022-2023/thu-gui-thanh-nien/TH%C6%AF_B%C3%81C_G%E1%BB%ACI_THANH_NI%C3%8AN_2_pym52t.webp',
        title: '',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685257730/2022-2023/thu-gui-thanh-nien/TH%C6%AF_B%C3%81C_G%E1%BB%ACI_THANH_NI%C3%8AN_3_htsxxw.webp',
        title: '',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685257730/2022-2023/thu-gui-thanh-nien/TH%C6%AF_B%C3%81C_G%E1%BB%ACI_THANH_NI%C3%8AN_4_fpmqa8.webp',
        title: '',
        sid: ''
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685257731/2022-2023/thu-gui-thanh-nien/TH%C6%AF_B%C3%81C_G%E1%BB%ACI_THANH_NI%C3%8AN_5_bpyzrz.webp',
        title: '',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685257729/2022-2023/thu-gui-thanh-nien/TH%C6%AF_B%C3%81C_G%E1%BB%ACI_THANH_NI%C3%8AN_6_yxail8.webp',
        title: '',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685257729/2022-2023/thu-gui-thanh-nien/TH%C6%AF_B%C3%81C_G%E1%BB%ACI_THANH_NI%C3%8AN_7_qgsxnd.webp',
        title: '',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685257729/2022-2023/thu-gui-thanh-nien/TH%C6%AF_B%C3%81C_G%E1%BB%ACI_THANH_NI%C3%8AN_8_edmejq.webp',
        title: '',
    },
    {
        imgUrl: 'https://res.cloudinary.com/yitute/image/upload/v1685257730/2022-2023/thu-gui-thanh-nien/TH%C6%AF_B%C3%81C_G%E1%BB%ACI_THANH_NI%C3%8AN_9_bljfap.webp',
        title: '',
    },
]